import { ALLOWED_METHODS } from '../schema';
import { createPostMessageClient } from '../post-message/client';

export function createIframeAdapter({ win = window, hostOrigin, onRejected }) {
    const client = createPostMessageClient({ win, target: win.parent, targetOrigin: hostOrigin, onRejected });

    const methods = Object.fromEntries(ALLOWED_METHODS.map((method) => [
        method,
        (payload, { signal } = {}) => client.request(method, payload, { signal }),
    ]));

    return {
        host: 'iframe',
        methods,
        dispose: () => client.dispose(),
    };
}
